import { Box, Dialog, DialogContent, Modal, Typography } from "@mui/material";
import { useState } from "react";

export function MBlogSection() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);

  const handleClick = (image: string) => {
    setSelected(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box display="flex" flexDirection="column" bgcolor="white">
        <Box display="flex" width="100%">
          <Box
            width="33.33%"
            sx={{ aspectRatio: 1 }}
            component="img"
            alt="Pop up blog 1"
            src="/images/store-detail/blog1.avif"
            onClick={() => handleClick("/images/store-detail/blog1.avif")}
          />
          <Box
            width="33.33%"
            sx={{ aspectRatio: 1 }}
            component="img"
            alt="Pop up blog 1"
            src="/images/store-detail/blog2.avif"
            onClick={() => handleClick("/images/store-detail/blog2.avif")}
          />
          <Box
            width="33.33%"
            sx={{ aspectRatio: 1 }}
            component="img"
            alt="Pop up blog 1"
            src="/images/store-detail/blog3.avif"
            onClick={() => handleClick("/images/store-detail/blog3.avif")}
          />
        </Box>

        <Box p={2}>
          <Typography fontWeight="bold" variant="h6" sx={{ my: 2 }}>
            石窯などの設備と食材にこだわるブッフェは五感で美味しさを知る{" "}
          </Typography>

          <Typography variant="body2">
            ホテルのオールデイダイニングとして、親しみのある定番の洋食メニューに加え、ブッフェでは上質な食材を贅沢に使用したレストラン自慢の料理の数々をブッフェラインにてご用意しています。又、ショーキッチンではお客様の目の前でシェフが調理し、華やかな雰囲気を演出しております。品数においても約100種類と豊富で、食べやすいポーションに仕上げた美しい料理を173席の広々とした店内でゆったりと寛いでお召し上がりいただけます。朝食からランチ、ディナーまで、さまざまな食事のスタイルで、、お客様の用途に合わせてご利用いただけます。{" "}
          </Typography>
        </Box>
      </Box>
      <Modal open={open} onClose={handleClose} style={{ outline: "none" }}>
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100vw",
            outline: "none",
          }}
        >
          {selected && (
            <img src={selected} alt="Select" style={{ width: "100%" }} />
          )}
        </Box>
      </Modal>
    </>
  );
}
